import { render, staticRenderFns } from "./AddTagInput.vue?vue&type=template&id=37ea5ec2&scoped=true&"
import script from "./AddTagInput.vue?vue&type=script&lang=js&"
export * from "./AddTagInput.vue?vue&type=script&lang=js&"
import style0 from "./AddTagInput.vue?vue&type=style&index=0&id=37ea5ec2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ea5ec2",
  null
  
)

export default component.exports